import { CountryState } from 'models/redux/country.state';
import { AnyAction, Reducer } from 'redux';

import {
  GET_COUNTRIES,
  GET_COUNTRIES_ERROR,
  SET_COUNTRIES,
  SET_SELECTED_COUNTRY
} from './country.types';

const initialState: CountryState = {
  countries: [],
  selectedCountry: undefined,
  loadingCountries: false
};

const reducer: Reducer<CountryState> = (
  state: CountryState = initialState,
  action: AnyAction = { type: undefined }
) => {
  switch (action.type) {
    case SET_SELECTED_COUNTRY:
    case GET_COUNTRIES:
      return { ...state, ...action.payload };

    case SET_COUNTRIES:
      return { ...state, ...action.payload, loadingCountries: false };

    case GET_COUNTRIES_ERROR:
      return { ...state, ...action.payload, loadingCountries: false };

    default:
      return state;
  }
};

export default reducer;
